/** Mobile reading panels: series submenu + table of contents overlays */

function closeAllPanels(): void {
  document.querySelector('.submenu')?.classList.remove('active')
  document.querySelector('.table-of-contents')?.classList.remove('active')
  document.querySelectorAll('#tools .tool.series, #tools .tool.toc').forEach((el) => {
    el.classList.remove('is-open')
    el.setAttribute('aria-expanded', 'false')
  })
}

export function initReadingPanels(): void {
  const submenu = document.querySelector<HTMLElement>('.submenu:not(.hidden)')
  const toc = document.querySelector<HTMLElement>('.table-of-contents:not(.hidden)')
  const seriesBtn = document.getElementById('series-toggle')
  const tocBtn = document.getElementById('toc-toggle')

  if (!seriesBtn && !tocBtn) return

  // Hide buttons when corresponding panel is absent
  if (!submenu && seriesBtn) seriesBtn.style.display = 'none'
  if (!toc && tocBtn) tocBtn.style.display = 'none'

  seriesBtn?.addEventListener('click', (e) => {
    e.stopPropagation()
    if (document.body.classList.contains('focus-mode')) return
    const opening = !submenu?.classList.contains('active')
    toc?.classList.remove('active')
    tocBtn?.classList.remove('is-open')
    tocBtn?.setAttribute('aria-expanded', 'false')
    submenu?.classList.toggle('active', opening)
    seriesBtn.classList.toggle('is-open', opening)
    seriesBtn.setAttribute('aria-expanded', opening ? 'true' : 'false')
  })

  tocBtn?.addEventListener('click', (e) => {
    e.stopPropagation()
    if (document.body.classList.contains('focus-mode')) return
    const opening = !toc?.classList.contains('active')
    submenu?.classList.remove('active')
    seriesBtn?.classList.remove('is-open')
    seriesBtn?.setAttribute('aria-expanded', 'false')
    toc?.classList.toggle('active', opening)
    tocBtn.classList.toggle('is-open', opening)
    tocBtn.setAttribute('aria-expanded', opening ? 'true' : 'false')
  })

  // Clicks inside panels should not dismiss
  submenu?.addEventListener('click', (e) => e.stopPropagation())
  toc?.addEventListener('click', (e) => e.stopPropagation())

  // TOC link click: navigate then close on mobile
  toc?.querySelectorAll('a').forEach((a) => {
    a.addEventListener('click', () => {
      if (window.matchMedia('(max-width: 1050px)').matches) {
        closeAllPanels()
      }
    })
  })

  document.addEventListener('click', () => closeAllPanels())
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllPanels()
  })
}
